<template>
  <div id="app">

    <div class="content-area">
      <!-- router-view 会根据当前的 URL 路径，渲染对应的 Vue 组件 -->
      <router-view />
    </div>
  </div>
</template>

<script>
// 注意：这里不再需要导入 BathroomProject，因为它现在是通过路由动态加载的
// import BathroomProject from './components/BathroomProject.vue'

export default {
  name: 'App',
  // 注意：这里不再需要注册 BathroomProject
  // components: {
  //   BathroomProject
  // }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 0;
  text-align: center; /* 让导航和内容居中 */
}

body {
  margin: 0;
  padding: 0;
}

nav {
  padding: 30px;
  background-color: #f0f2f5;
  border-bottom: 1px solid #e0e2e5;
  margin-bottom: 20px; /* 导航和内容之间留出一些空间 */
}

nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
  padding: 10px 15px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

nav a:hover {
  background-color: #e6e8eb;
}

nav a.router-link-exact-active {
  color: #42b983; /* 当前激活链接的颜色 */
  background-color: #e0f0e6;
}

.content-area {
  padding: 0; /* removed horizontal padding */
}
</style>